export const fonts = {"fonts":[]};